import HttpService from "common/http/httpService";
import FcmAccount from "./fcmAccount";
import Throttle from "common/decorators/throttle";

class FcmAccountsService extends HttpService {
    @Throttle(1000, true, false)
    async listFcmAccounts(): Promise<FcmAccount[]> {
        const response = await this.getClient().get<FcmAccount[]>('/settings/v1/fcmaccounts');
        return response.data;
    }
}
const fcmAccountsService = new FcmAccountsService();
export default fcmAccountsService;
